
/**
 * Custom JS to hide Bundler App Popup - NUCLEAR VERSION
 * 
 * This script actively monitors the DOM for the "You got ... OFF your order" popup
 * and removes it instantly. It uses multiple strategies:
 * 1. Known CSS selectors
 * 2. Text content analysis ("You got" + "OFF your order")
 * 3. Computed style analysis (high z-index + fixed position)
 */

(function() {
    const DEBUG = false; // Set to true to see console logs
    
    const log = (msg) => {
        if (DEBUG) console.log(`[BundlerHide] ${msg}`);
    };

    const hideBundlerPopup = () => {
      // Strategy 1: Hide by Known Selectors
      const selectors = [
        '#bndlr-discount-popup',
        '.bndlr-discount-popup',
        '#bundler-modal',
        '[id^="bundler-popup-"]',
        'div[class*="bundler-popup"]',
        'div[class*="bndlr-popup"]',
        '.bundler-modal',
        '#bundler-target-element-modal',
        '.bundler-target-element'
      ];
      
      selectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
            log(`Hiding element by selector: ${sel}`);
            el.style.display = 'none';
            el.style.setProperty('display', 'none', 'important');
            el.style.visibility = 'hidden';
            el.style.setProperty('visibility', 'hidden', 'important');
            el.style.opacity = '0';
            el.style.pointerEvents = 'none';
        });
      });
  
      // Strategy 2: Hide by Text Content (The "Nuclear Option")
      // We look for elements containing the specific text string.
      // We scan all divs that are potential containers.
      const candidates = document.querySelectorAll('div, section, aside');
      
      candidates.forEach(el => {
        // Optimization: Skip if already hidden
        if (el.style.display === 'none') return;
        
        // Check text content
        // We look for the exact phrase "OFF your order" which is very specific to this popup
        if (el.innerText && el.innerText.includes('OFF your order') && el.innerText.includes('You got')) {
          
          // We found the text. Now we need to find the ACTUAL popup container.
          // It's likely the element itself or a close parent that is floating/fixed.
          
          // Check if this element itself is the popup (has fixed position or high z-index)
          const style = window.getComputedStyle(el);
          const isFixed = style.position === 'fixed' || style.position === 'absolute';
          const hasHighZ = parseInt(style.zIndex) > 100;
          
          if (isFixed || hasHighZ) {
             log('Hiding element by text content (direct match)');
             el.style.display = 'none';
             el.style.setProperty('display', 'none', 'important');
          } else {
             // Climb up to find the modal container
             let parent = el.parentElement;
             let foundContainer = false;
             
             // Check up to 5 levels up
             for (let i = 0; i < 5; i++) {
                if (!parent) break;
                
                const pStyle = window.getComputedStyle(parent);
                if (pStyle.position === 'fixed' || parseInt(pStyle.zIndex) > 900) {
                    log('Hiding parent element by text content');
                    parent.style.display = 'none';
                    parent.style.setProperty('display', 'none', 'important');
                    foundContainer = true;
                    break;
                }
                parent = parent.parentElement;
             }
             
             // If no container found, hide the element itself just to be safe
             if (!foundContainer) {
                 el.style.display = 'none';
                 el.style.setProperty('display', 'none', 'important');
             }
          }
        }
      });
    };
  
    // Run immediately
    hideBundlerPopup();
    
    // Run on load
    window.addEventListener('load', hideBundlerPopup);
    document.addEventListener('DOMContentLoaded', hideBundlerPopup);
    
    // Run repeatedly (Polling) - aggressively at first, then slower
    // This catches popups that appear after user interaction (like adding to cart)
    let checkCount = 0;
    const interval = setInterval(() => {
        hideBundlerPopup();
        checkCount++;
        // Run frequently for the first 30 seconds, then slow down
        if (checkCount > 60) { // 30 seconds (60 * 500ms)
            clearInterval(interval);
            setInterval(hideBundlerPopup, 2000); // Check every 2 seconds forever
        }
    }, 500);
  
    // Run on mutation (dynamic injection)
    const observer = new MutationObserver((mutations) => {
        hideBundlerPopup();
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Also listen for clicks, as they often trigger these popups
    document.addEventListener('click', () => {
        setTimeout(hideBundlerPopup, 100);
        setTimeout(hideBundlerPopup, 500);
        setTimeout(hideBundlerPopup, 1000);
    });
  })();

/**
 * Custom JS to FORCE Cart Icon Visibility - NUCLEAR RESURRECTION
 * 
 * This script checks if the cart icon is missing and injects it back.
 * It is the ultimate failsafe for the "thermosleep" product page issue.
 */
(function() {
    const ensureCartIcon = async () => {
        const cartLink = document.getElementById('cart-icon-bubble');
        if (!cartLink) return;

        // Check if SVG exists
        const svg = cartLink.querySelector('svg');
        if (!svg) {
            console.log('[CartResurrection] Icon missing! Fetching cart data and injecting...');
            
            try {
                // Fetch current cart state to get accurate item count
                const res = await fetch('/cart.js');
                const cart = await res.json();
                const itemCount = cart.item_count;

                // Prepare Counter HTML
                let countHTML = '';
                if (itemCount > 0) {
                     countHTML = `<span class="wt-header__panel__counter" style="display: flex !important; visibility: visible !important;">${itemCount}</span>`;
                }

                // Inject the hardcoded SVG + Count
                const iconHTML = `
                <svg class="svg-icon svg-icon--bag" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" style="display: inline-block !important; width: 28px !important; height: 28px !important; fill: currentColor !important; color: inherit !important; visibility: visible !important; opacity: 1 !important;">
                    <title>Cart</title>
                    <g id="cart">
                        <path d="m1.87025,4a0.87,0.87 0 1 0 0,1.741l1.6,0a0.863,0.863 0 0 1 0.854,0.707l0.173,0.907l1.871,9.827a3.782,3.782 0 0 0 3.706,3.065l10.864,0a3.781,3.781 0 0 0 3.706,-3.065l1.871,-9.827a0.87,0.87 0 0 0 -0.854,-1.034l-19.59,0l-0.037,-0.2a2.62,2.62 0 0 0 -2.565,-2.121l-1.599,0zm4.53,4.062l18.2,0l-1.675,8.794a2.022,2.022 0 0 1 -2,1.65l-10.851,0a2.023,2.023 0 0 1 -2,-1.65l0,0l-1.674,-8.794zm5.041,13.345a1.741,1.741 0 1 0 1.741,1.741a1.741,1.741 0 0 0 -1.738,-1.741l-0.003,0zm8.123,0a1.741,1.741 0 1 0 1.741,1.741a1.741,1.741 0 0 0 -1.738,-1.741l-0.003,0z" fill="currentColor"/>
                        <rect x="1.00025" y="2" fill="none" height="24" width="26"/>
                    </g>
                </svg>
                ${countHTML}
                <span class="wt-header__panel__label">Warenkorb</span>
                `;
                cartLink.innerHTML = iconHTML; 
            } catch (e) {
                console.error('[CartResurrection] Failed to recover cart icon:', e);
            }
        }
    };

    // Run heavily
    setInterval(ensureCartIcon, 500); // Check every 500ms
    document.addEventListener('cart-drawer:refresh', () => setTimeout(ensureCartIcon, 100));
    document.addEventListener('cart-drawer:refresh', () => setTimeout(ensureCartIcon, 500));
    document.addEventListener('cart-drawer:refresh', () => setTimeout(ensureCartIcon, 1000));
})();

/**
 * Force Shopify market country to match the active country-specific domain.
 * This keeps storefront prices aligned with the checkout currency on .ch/.de.
 */
(function() {
    const host = window.location.hostname.toLowerCase();
    let expectedCountry = null;

    if (host.endsWith('.ch')) {
        expectedCountry = 'CH';
    } else if (host.endsWith('.de')) {
        expectedCountry = 'DE';
    }

    if (!expectedCountry) return;

    const storageKey = `market-sync:${expectedCountry}:${window.location.pathname}${window.location.search}`;
    const currentPath = `${window.location.pathname}${window.location.search}`;

    function submitCountryForm() {
        const form = document.getElementById('DrawerCountryForm');
        if (!form) return false;

        const countryInput = form.querySelector('input[name="country_code"]');
        const returnInput = form.querySelector('input[name="return_to"]');
        const currentCountry = countryInput ? (countryInput.value || '').toUpperCase() : '';

        if (!countryInput || currentCountry === expectedCountry) {
            return false;
        }

        if (sessionStorage.getItem(storageKey) === 'submitted') {
            return false;
        }

        countryInput.value = expectedCountry;
        if (returnInput) {
            returnInput.value = currentPath || '/';
        }

        sessionStorage.setItem(storageKey, 'submitted');
        form.submit();
        return true;
    }

    document.addEventListener('DOMContentLoaded', function() {
        if (submitCountryForm()) return;

        // Clear the one-shot flag once the storefront country matches the domain.
        const form = document.getElementById('DrawerCountryForm');
        const countryInput = form ? form.querySelector('input[name="country_code"]') : null;
        if (countryInput && (countryInput.value || '').toUpperCase() === expectedCountry) {
            sessionStorage.removeItem(storageKey);
        }
    });
})();

/**
 * Keep Bundler-rendered price labels aligned with the current market presentation.
 * This only normalizes already rendered amounts inside Bundler containers.
 */
(function() {
    const containerSelector = '[class*="bundler"], [id*="bundler"], [class*="bndlr"], [id*="bndlr"]';
    const priceOnlyPattern = /^(?:CHF|EUR|€)\s?\d[\d\s.,']*$|^\d[\d\s.,']*\s?€$/;

    function getMarketConfig() {
        const host = window.location.hostname.toLowerCase();
        const htmlLang = document.documentElement.lang || 'de-DE';

        if (host.endsWith('.ch')) {
            return { currency: 'CHF', locale: 'de-CH' };
        }

        if (host.endsWith('.de')) {
            return { currency: 'EUR', locale: 'de-DE' };
        }

        if (window.Shopify && Shopify.currency && Shopify.currency.active) {
            return { currency: Shopify.currency.active, locale: htmlLang };
        }

        return { currency: 'EUR', locale: htmlLang };
    }

    function parsePrice(text) {
        const cleaned = text.replace(/[^\d,.'\s]/g, '').trim();
        if (!cleaned) return null;

        const lastComma = cleaned.lastIndexOf(',');
        const lastDot = cleaned.lastIndexOf('.');
        let normalized = cleaned;

        if (lastComma > lastDot) {
            normalized = cleaned.replace(/\./g, '').replace(/'/g, '').replace(/\s/g, '').replace(',', '.');
        } else {
            normalized = cleaned.replace(/,/g, '').replace(/'/g, '').replace(/\s/g, '');
        }

        const value = Number(normalized);
        return Number.isFinite(value) ? value : null;
    }

    function formatPrice(value, config) {
        return new Intl.NumberFormat(config.locale, {
            style: 'currency',
            currency: config.currency,
            currencyDisplay: config.currency === 'CHF' ? 'code' : 'symbol',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }

    function normalizePriceElement(element, config) {
        if (!element || element.children.length > 0) return;

        const text = (element.textContent || '').trim().replace(/\s+/g, ' ');
        if (!priceOnlyPattern.test(text)) return;

        const value = parsePrice(text);
        if (value === null) return;

        const formatted = formatPrice(value, config);
        if (text !== formatted) {
            element.textContent = formatted;
        }
    }

    function normalizeBundlerPrices(root) {
        const config = getMarketConfig();
        const containers = [];

        if (root && root.nodeType === 1 && root.matches(containerSelector)) {
            containers.push(root);
        }

        if (root && root.querySelectorAll) {
            root.querySelectorAll(containerSelector).forEach((container) => containers.push(container));
        }

        containers.forEach((container) => {
            normalizePriceElement(container, config);
            container.querySelectorAll('*').forEach((element) => normalizePriceElement(element, config));
        });
    }

    const runNormalization = (root = document.body || document.documentElement) => {
        if (!root) return;
        normalizeBundlerPrices(root);
    };

    document.addEventListener('DOMContentLoaded', () => runNormalization());
    window.addEventListener('load', () => runNormalization());
    setInterval(() => runNormalization(), 1500);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) {
                    runNormalization(node);
                }
            });
        });
    });

    if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
    } else {
        document.addEventListener('DOMContentLoaded', () => {
            observer.observe(document.body, { childList: true, subtree: true });
        });
    }
})();
